export const DocTypeEnum = {
  DNI: 1,
  PAS: 2,
  CEX: 3,
  PTP: 4,
};